import { Action } from '@ngrx/store';
import { IPulseType } from '@shared/models/entities';

export enum CommonActionTypes {
    DisplayServerError = '[Common] Display Server Error',
    EmptyAction = '[Common] Empty Action',
    NavigateToSubmitPage = '[Common] Navigate To Submit Page',
    GetHowHeardAboutTypes = '[Common] Get How Heard About Types',
    GetHowHeardAboutTypesSuccess = '[Common] Get How Heard About Types Success',
    GetCountryTypes = '[Common] Get Country Types',
    GetCountryTypesSuccess = '[Common] Get Country Types Success',
    GetSuffixTypes = '[Common] Get Suffix Types',
    GetSuffixTypesSuccess = '[Common] Get Suffix Types Success',
    GetContactMethodTypes = '[Common] Get Contact Method Types',
    GetContactMethodTypesSuccess = '[Common] Get Contact Method Types Success',
    GetUSStateTypes = '[Common] Get US States Types',
    GetUSStateTypesSuccess = '[Common] Get US States Types Success',
    GetCanadaProvinceTypes = '[Common] Get Canada Province Types',
    GetCanadaProvinceTypesSuccess = '[Common] Get Canada Province Types Success',
    GetTimeZoneTypes = '[Common] Get Time Zone Types',
    GetTimeZoneTypesSuccess = '[Common] Get Time Zone Types Success',
    GetMetroAreaTypes = '[Common] Get Metro Area Types',
    GetMetroAreaTypesSuccess = '[Common] Get Metro Area Types Success',
    GetSchoolDegreeTypes = '[Common] Get School Degree Type',
    GetSchoolDegreeTypesSuccess = '[Common] Get School Degree Type Success',
    RedirectToUrl = '[Common] Redirect To Url',
    RedirectToMyAccount = '[Common] Redirect To My Account',
    NavigateToChangePassword = "[Common] Navigate To Change Password"
}

export class DisplayServerError implements Action {
    readonly type = CommonActionTypes.DisplayServerError;
    constructor(public payload?: string | Array<string>) { }
}
export class EmptyAction implements Action {
    readonly type = CommonActionTypes.EmptyAction;
    constructor() { }
}
export class NavigateToSubmitPage implements Action {
    readonly type = CommonActionTypes.NavigateToSubmitPage;
    constructor() { }
}

export class NavigateToChangePassword implements Action {
    readonly type = CommonActionTypes.NavigateToChangePassword;
    constructor(public payload: number) { }
}

export class GetHowHeardAboutTypes implements Action {
    readonly type = CommonActionTypes.GetHowHeardAboutTypes;
    constructor() { }
}
export class GetHowHeardAboutTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetHowHeardAboutTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetCountryTypes implements Action {
    readonly type = CommonActionTypes.GetCountryTypes;
    payload: any;
    constructor() { }
}
export class GetCountryTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetCountryTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetSuffixTypes implements Action {
    readonly type = CommonActionTypes.GetSuffixTypes;
    constructor() { }
}
export class GetSuffixTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetSuffixTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetContactMethodTypes implements Action {
    readonly type = CommonActionTypes.GetContactMethodTypes;
    constructor() { }
}
export class GetContactMethodTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetContactMethodTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetUSStateTypes implements Action {
    readonly type = CommonActionTypes.GetUSStateTypes;
    constructor() { }
}
export class GetUSStateTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetUSStateTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetCanadaProvinceTypes implements Action {
    readonly type = CommonActionTypes.GetCanadaProvinceTypes;
    constructor() { }
}
export class GetCanadaProvinceTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetCanadaProvinceTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetTimeZoneTypes implements Action {
    readonly type = CommonActionTypes.GetTimeZoneTypes;
    constructor() { }
}
export class GetTimeZoneTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetTimeZoneTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetMetroAreaTypes implements Action {
    readonly type = CommonActionTypes.GetMetroAreaTypes;
    constructor() { }
}
export class GetMetroAreaTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetMetroAreaTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class GetSchoolDegreeTypes implements Action {
    readonly type = CommonActionTypes.GetSchoolDegreeTypes;
    constructor() { }
}
export class GetSchoolDegreeTypesSuccess implements Action {
    readonly type = CommonActionTypes.GetSchoolDegreeTypesSuccess;
    constructor(public payload: IPulseType[]) { }
}
export class RedirectToUrl implements Action {
    readonly type = CommonActionTypes.RedirectToUrl;
    constructor(public payload: string) { }
}

export class RedirectToMyAccount implements Action {
    readonly type = CommonActionTypes.RedirectToMyAccount;
    constructor(public payload: number) { }
}
export type CommonActions =
    | DisplayServerError
    | NavigateToSubmitPage
    | NavigateToChangePassword
    | GetHowHeardAboutTypes
    | GetHowHeardAboutTypesSuccess
    | GetCountryTypes
    | GetCountryTypesSuccess
    | GetSuffixTypes
    | GetSuffixTypesSuccess
    | GetContactMethodTypes
    | GetContactMethodTypesSuccess
    | GetUSStateTypes
    | GetUSStateTypesSuccess
    | GetCanadaProvinceTypes
    | GetCanadaProvinceTypesSuccess
    | GetTimeZoneTypes
    | GetTimeZoneTypesSuccess
    | GetMetroAreaTypes
    | GetMetroAreaTypesSuccess
    | GetSchoolDegreeTypes
    | GetSchoolDegreeTypesSuccess
    | RedirectToUrl
    | RedirectToMyAccount;
